import { render, staticRenderFns } from "./ChecklistFile.vue?vue&type=template&id=5f80d77e&scoped=true"
import script from "./ChecklistFile.vue?vue&type=script&lang=js"
export * from "./ChecklistFile.vue?vue&type=script&lang=js"
import style0 from "./ChecklistFile.vue?vue&type=style&index=0&id=5f80d77e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80d77e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f80d77e')) {
      api.createRecord('5f80d77e', component.options)
    } else {
      api.reload('5f80d77e', component.options)
    }
    module.hot.accept("./ChecklistFile.vue?vue&type=template&id=5f80d77e&scoped=true", function () {
      api.rerender('5f80d77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/customer/onboarding/ChecklistFile.vue"
export default component.exports